import { ClaimType } from '~/utils/constants';
import { checkIfPastReturnWindow } from '~/utils/order';
import { makeCrewLoader, redirect } from '~/utils/routing';
import { getClaimTypeProgramName } from '~/utils/theme';

export const { loader, useLoaderData } = makeCrewLoader(
  ({ context: { order, settings } }) => {
    if (order.allowClaimTypeSelection) {
      return {
        ...order.allowClaimTypeSelection.params,
        returnProgramName: getClaimTypeProgramName(
          settings.theme,
          ClaimType.return,
        ),
        warrantyProgramName: getClaimTypeProgramName(
          settings.theme,
          ClaimType.warranty,
        ),
      };
    }

    const canWarranty =
      settings.warranty.isEnabled &&
      order.lineItems.every(checkIfPastReturnWindow(settings.return.isEnabled));

    const claimType = canWarranty ? ClaimType.warranty : ClaimType.return;

    return redirect(`../${claimType.toLowerCase()}`);
  },
);
